import { OnInit } from '@angular/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[] = [];

    ngOnInit() {
        this.model = [
            {
                label: 'Dashboards',
                icon: 'pi pi-home',
                items: [
                    {
                        label: 'Dashboard',
                        icon: 'pi pi-fw pi-ticket',
                        items: [
                            {
                                label: 'Deals',
                                icon: 'pi pi-fw pi-globe',
                                routerLink: ['/dashboard']
                            },
                            {
                                label: 'Flight Preferences',
                                icon: 'pi pi-fw pi-globe',
                                routerLink: ['/dashboard/preferences']
                            }
                        ]
                    },
                    {
                        label: 'Member Perks',
                        icon: 'pi pi-fw pi-user',
                        routerLink: ['/member-perks']
                    },
                    {
                        label: 'Rewards',
                        icon: 'pi pi-fw pi-gift',
                        routerLink: ['/rewards']
                    },
                    {
                        label: 'Newsletter',
                        icon: 'pi pi-fw pi-envelope',
                        url: 'https://dollarflightclub.com/navigator-newsletter/',
                        target: '_blank'
                    },
                    {
                        label: 'E-Commerce',
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/']
                    },
                    {
                        label: 'Banking',
                        icon: 'pi pi-fw pi-image',
                        routerLink: ['/dashboard-banking']
                    },
                ]
            }
        ];
    }
}
